import { QueryBuilderSelector } from './QueryBuilderSelector';
import { useEffect, useState } from 'react';
import { executeQuery } from '../../../../queries';
import { values } from 'lodash';
import { METRIC_SELECTOR } from './DataPanelConstants';
import { Input } from '@appd/uik';

interface QueryBuilderMetricSelectorProps {
  alias: string;
  entities: string[];
  value: string;
  source: string;
  options: string[] | undefined;
  fields: string;
  onChange: (e: string) => void;
  onAliasChange: (e: string) => void;
  onSourceChange: (e: string) => void;
  onFieldsChange: (e: string) => void;
}

export const QueryBuilderMetricSelector = ({
  alias,
  entities,
  value,
  source,
  options,
  fields,
  onChange,
  onAliasChange,
  onSourceChange,
  onFieldsChange,
}: QueryBuilderMetricSelectorProps) => {
  const [sourceOptions, setSourceOptions] = useState<string[]>([]);

  useEffect(() => {
    if (value && entities && entities.length > 0) {
      executeQuery(`FETCH sources(${value}) FROM entities(${entities[0]})`).then((res: any) => {
        setSourceOptions(values(res.data[0].sources[0]).concat([METRIC_SELECTOR.ALLSOURCES]));
      });
    }
  }, [value, entities]);

  return (
    <div className="flex grow flex-row divide-x rounded-md border-2 mt-2 py-2">
      <div className="text-base w-[75px] text-center">Metrics</div>
      <div className="min-w-[150px] pl-2 flex flex-row">
        <div className="pr-2">
          <div className="text-sm leading-5">Alias</div>
          <div className="text-base">
            <Input
              className="px-2 border-2 rounded-md truncate w-[80px]"
              style={{}}
              onChange={e => {
                onAliasChange(e.target.value);
              }}
              placeholder={'Enter Metric Alias'}
              value={alias}
            />
          </div>
        </div>
        <div>
          <div className="text-sm leading-5">Metric Type</div>
          <div className="flex selector-container">
            <div className="w-[250px]">
              <QueryBuilderSelector
                value={value}
                placeHolder="Select Metric Type"
                options={options}
                onChange={e => onChange(e)}
              ></QueryBuilderSelector>
            </div>
          </div>
        </div>
        {value && (
          <div className="flex flex-row">
            <div>
              <div className="text-sm leading-5">Source</div>
              <div className="flex selector-container">
                <div className="w-[200px]">
                  <QueryBuilderSelector
                    value={source}
                    placeHolder="Select Source"
                    options={sourceOptions}
                    onChange={e => onSourceChange(e)}
                  ></QueryBuilderSelector>
                </div>
              </div>
            </div>
            <div className="pr-2">
              <div className="text-sm leading-5">Field</div>
              <div className="text-base">
                <Input
                  className="px-2 border-2 rounded-md truncate w-[200px]"
                  style={{}}
                  onChange={e => {
                    onFieldsChange(e.target.value);
                  }}
                  placeholder={'Enter Fields(optional)'}
                  value={fields}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
